import { todayUTC, yesterdayUTC } from './dates';

/** 服务端接口客户端。阶段 2 只有 GET /seed；其余接口阶段 5 接入。 */

/** 生产构建经 VITE_API_BASE 指向 Worker；dev 走 Vite 代理 /api。 */
export const API_BASE: string =
  (import.meta.env.VITE_API_BASE as string | undefined) ?? '/api';

export interface SeedBundle {
  date: string;
  seed: number;
}

/** 拉取指定 UTC 日期的种子；种子只由服务端下发，客户端不推导。 */
async function fetchSeed(date: string): Promise<SeedBundle> {
  const res = await fetch(`${API_BASE}/seed?date=${date}`);
  if (!res.ok) throw new Error(`seed fetch failed: HTTP ${res.status}`);
  return (await res.json()) as SeedBundle;
}

/** 日课：今日种子（00:00 UTC 刷新）。 */
export function fetchDailySeed(now: Date = new Date()): Promise<SeedBundle> {
  return fetchSeed(todayUTC(now));
}

/** 练习：固定 T-1（昨天）种子，禁止用当日种子练习。 */
export function fetchPracticeSeed(now: Date = new Date()): Promise<SeedBundle> {
  return fetchSeed(yesterdayUTC(now));
}
